// extracted by mini-css-extract-plugin
export default {"header":"pageHeader_header__Qiq3g","title":"pageHeader_title__HenNg","wrapper":"pageHeader_wrapper__4fCAL","label":"pageHeader_label__JRkgl"};